import { Select } from 'components/Select';
import { LISTING_TYPE_HUMAN_NAME_MAP_SEARCH } from 'utils/constants';
import { compose, getter } from 'utils/functional';

type DisplayedType = ListingType | StaffTypeFilter;

type Props = {
  value: string;
  onChange: (arg0: ListingType) => void;
  listingTypes: Array<DisplayedType>;
};

export function ListingTypeSelect({
  value,
  onChange,
  listingTypes,
  ...props
}: Props) {
  const options = listingTypes.map((type) => ({
    value: type,
    label: LISTING_TYPE_HUMAN_NAME_MAP_SEARCH[type],
  }));
  const selectValue = options.map(({ value: v }) => v).find((v) => v === value);
  return (
    <Select
      data-qa-id="listing-type-select"
      aria-label={getText('Select listing type')}
      name="listing-types"
      options={options}
      value={selectValue}
      onChange={compose(onChange, getter('value'))}
      isSearchable={false}
      isClearable={false}
      disabled={listingTypes.length === 1}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}
